import dayjs from 'dayjs';

// Входящий звонок завершился, трубку не взяли
export const isMissedCall = (call) =>
    !!call
    && Number(call.direction) === 1
    && call.endedOn != null
    && call.answeredOn == null;

// Непрочитанный диалог: id прочитанного сообщения отстаёт от последнего
export const isDialogUnread = (d) =>
    d?.lastMessageId != null
    && (d.lastMessageIdIsRead == null || d.lastMessageIdIsRead < d.lastMessageId);

// Заголовок диалога: имя диалога → введённое имя → контрагент → #id
export const dialogTitle = (d) => {
    if (!d) return '';
    return d.name || d.enteredName || d.contragentName || `#${d.id}`;
};

// Время в журнале: сегодня — HH:mm, иначе DD.MM HH:mm
export const formatDialogTime = (value) => {
    const d = dayjs(value);
    if (!d.isValid()) return '';
    return d.isSame(dayjs(), 'day') ? d.format('HH:mm') : d.format('DD.MM HH:mm');
};
